import { takeLatest, call, put } from 'redux-saga/effects'
import { createOpenEndedQuestion } from 'api/administration/questions/Create'
import { getQuestionList } from 'api/administration/questions/List'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/questions.action'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

async function handleCreateOpenEnded(data: IOpenEndedModel) {
  return await createOpenEndedQuestion(data)
}

function* newOpenEndedEffectSaga(action: any) {
  try {
    const {
      data: { data, instanceId },
    } = action
    yield call(handleCreateOpenEnded, data)
    const questionList = yield call(getList, instanceId)
    yield put(fromActions.Actions.questionsListSuccess(questionList))
  } catch (error) {
    // Without this the question editor and cards stay behind a loader.
    yield put(fromActions.Actions.setQuestionLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.createError'))
    console.log('error: ', error)
  }
}

export function* createOpenEndedtWatcherSaga() {
  yield takeLatest(
    fromActions.QUESTION_OPENENDED_CREATE,
    newOpenEndedEffectSaga
  )
}
